export default __webpack_public_path__ + "static/media/before-footer-img8.462cf515.png";